var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"gppa"}},[_c('populate-dynamically',{ref:"choices",attrs:{"field":_vm.field,"populate":"choices"}}),_vm._v(" "),_c('populate-dynamically',{ref:"values",attrs:{"field":_vm.field,"populate":"values"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }